/* eslint-disable */  
<template>
    <section>
        <div v-if="!user" >
            <div class="register-form-container">
                <!-- <form id="head"  novalidate autocomplete="off"> -->
                    <br> <br> <br> <br> <br>
                <div class="heading">
                <span>Please Loging First.....</span>
                
                <h3><router-link class="btn dark"  to="/login">Login</router-link></h3>
                </div>
          
            <h3><b></b></h3>
            </div>
            
                 <!-- </form> -->
            
        </div>
        
        <div v-else  class="register-container">
        <div class="register-form-container">
 
            
            <form id="Invoince"  novalidate autocomplete="off">
                <pre>DateTime :{{ new Date().toLocaleString()}}</pre>
                <div class="heading">
                <span>Local Government Online Payment Management System</span>
                    <h3><b>Payment Reciept</b></h3>
                 </div>
                <div  class="table-responsive">
                    <h5 v-if="theSabhaData && theSabhaData[0]">{{ theSabhaData[0].sb_name_en}},{{ theSabhaData[0].sb_address }}</h5> 
                    <h5 v-if="theSabhaData && theSabhaData[0]">Tel:{{ theSabhaData[0].sb_contact}}, Fax:{{ theSabhaData[0].fax}}</h5> 
                  <h6>Invoice No : &nbsp;{{ InvouceNum }} </h6>
                <table class="table ">
        
                    <tbody>
                        <tr>
                            <td class="bg-light-gray"><label for="Uname"><b>Your NIC | හැඳුනුම්පත් අංකය</b></label></td>
                            <td > <label for="Uname">{{ user.cus_nic }} </label></td>
                        </tr>
                        <tr>
                            <td class="bg-light-gray"><label for="Uname"><b>Your Name | නම</b></label></td>
                            <td ><label for="Uname">{{ user.cus_name }}</label></td>
                        </tr>
                       
                       
                        <tr>
                            <td class="bg-light-gray"> <label for="month"><b>Pay Amount | ගෙවන මුදල(රු.) </b></label></td>
                            <td ><label for="Uname">{{ payamount }}</label> </td> 
                            
                        </tr>
                        <tr>
                            <td class="bg-light-gray"> <label for="month"><b>Banking Service Charge | බැංකුව මගින් අය කරනු ලබන සේවා ගාස්තු  </b></label></td>
                            <td ><label for="Uname">{{ bankfee }}</label> </td> 
                            
                        </tr>
                        <tr>
                            <td class="bg-light-gray"> <label for="month"><b>Gand Total | ගෙවිය යුතු මුළු මුදල </b></label></td>
                            <td ><label for="Uname">{{ grandPayTotal}}</label> </td> 
                            
                        </tr>
                        <tr>
                            <td class="bg-light-gray"><label for="rdes"><b>Remarks  | ගෙවීම් විස්තරය</b> </label></td>
                            <td ><label for="Uname">Payment for Gully Bowser(චූෂණ බවුසරය සඳහා ගෙවීම)</label></td>
                        </tr>
                    </tbody>
                </table>
                </div>
              
            <br>
            <div class="table-responsive">  
                <h6><input @click="btnenable"  type="checkbox" id="checkid" v-model="checkVal"  >&nbsp;I certify that the above information is true and correct.| ඉහත තොරතුරු සත්‍ය හා නිවැරදි බවට සහතික කරමි. </h6>
                <!-- <input type="button" id="cancel" class="btn" value="Cancel"/> -->
                <button class="btn " id="payboc"  type="submit" :disabled="disableButton">Pay Now</button>
                </div>
            </form>
            <br>
                <div v-html="form" id="formResponse" class="form-group aling" style="display: none;"></div>
               
                <br>

                <!-- <div id="embed-target"> </div> -->
                <!-- <input class="form-group aling" type="button" value="Pay with Embedded Page" onclick="Checkout.showEmbeddedPage('#embed-target');" /> -->
        <!-- <input class="form-group aling" type="button" value="Pay with Payment Page" onclick="this.Checkout.showPaymentPage();" /> -->
        <!-- <input class="form-group aling" type="button" value="Pay with Payment Page" @click="showPaymentPage" /> -->
        </div>
    </div>
</section>
</template>


<script>

// import router from "@/router";
import axios from "axios";
import { mapMutations } from "vuex";
import { mapState } from "vuex";

export default {
   
    name: "GullyInvoice",
  
    data() {
        return {
                   
                        // Sname:'scsad',
                        grandPayTotal:0,bankfee:0,
                        cusName:'',Sname:'',
                        monthName:'',
                        checkVal:'',
                        sessionData:'',
                        InvouceNum:'',sabha_code:'',
                        pay_head:0,
                        nextid:'',
                        Nic:'',
                        payamount:'',
                        theSabhaData:[],
                        matchUser:undefined,
                        matchPaymonth:[],
                        onlinPaydata:[],
                        shopDeID:[],
                        temp:[],
                        AllShopDtails:[],
                        postData: {
                            mid:'',
                            paytype:'',
                            amount:'',
                            referenceNumber: '',
                            email:'',
                            bill_to_forename:'',
                            bill_to_surname:'',
                            bill_to_address_line1:'',
                            bill_to_address_line2:'',
                            bill_to_address_city:'',
                            bill_to_address_state:'',
                            bill_to_address_postal_code:'',
                            bill_to_address_country:'LK',
                        },
                        response: null,
                        error: null,
                        currentDate: new Date(),
                        // date:new Date(),
                       fine:0,totalshoprent:0,
                       Checkout: null,
                        requestId:'',
                        reqdata:'',
                        pay_vote:'',
                        ipg:''
                        
                     
                      
        
                        
                       
        }
    },

        created() {
            this.getSessionData();
        //    this.LoadData();
           this.ShowMonthName();
        //    this.getshopdata();
        },
        computed : {
            ...mapState(["user"]),

             
         },
    //      mounted() {
    //     // Load the checkout script
    //     const script = document.createElement('script');
    //     script.src = "http://test-bankofceylon.mtf.gateway.mastercard.com/static/checkout/checkout.min.js";
    //     script.onload = () => {
    //         // Initialize the Checkout object after the script is loaded
    //         this.Checkout = window.Checkout;
    //         // Configure callbacks
    //         this.Checkout.configure({
    //             error: this.errorCallback,
    //             cancel: this.cancelCallback
    //         });
    //         // You may also call any initialization function here
    //         this.initPaymentIntegration();
    //     };
    //     document.head.appendChild(script);
    // },
    methods: {
        ...mapMutations(["setUser"]),

        formattedDate: function() {
         const day = this.currentDate.getDate().toString().padStart(2, "0");
         const month = (this.currentDate.getMonth() + 1)
           .toString()
           .padStart(2, "0");
         const year = this.currentDate.getFullYear().toString();
         var defaultdate =`${year}-${month}-${day}`
        //  return `${year}-${month}-${day}`;
        return defaultdate
       },

        async MatchUser(nic) {
            let data = await axios.get('/customersdata/' + nic);
            this.matchUser = data.data;
        },
       
  

  
       async getSessionData(){
        
        const redata=JSON.parse(sessionStorage.getItem('reqId'));
            if(redata){
                this.requestId=redata.req_ID
            }
            this.sessionData=redata;
            // this.payamount=JSON.parse(sessionStorage.getItem('payamounts'));
            const nicdata=JSON.parse(sessionStorage.getItem('Userdata'));
            if(nicdata){
                this.Nic=nicdata.Unic
            }
            await this.MatchUser(this.Nic);
            this.setUser(this.matchUser);
            let lastGennum=null
        if(this.sessionData){

            this.reqdata = (await axios.get('/gullyrequestgid/' + this.requestId)).data
            this.sabha_code=this.reqdata[0].sabha_code
            this.pay_vote=this.reqdata[0].vote
            
            this.theSabhaData = (await axios.get('/PraSabhadata/' + this.sabha_code)).data
            this.Sname='gully'
            this.ipg= this.theSabhaData[0].saba_ipg

            // this.AllShopDtails = (await axios.get('/shopdata/'+this.shopDeID )).data;
            let datau = await axios.get('/customersdata/' + this.user.cus_nic);
            this.matchUser = datau.data;
            this.cusName=this.matchUser.cus_name;
            this.onlinPaydata= (await axios.get('/genaratenum/')).data;
            lastGennum=parseInt(this.onlinPaydata[0].gen_num);
           
            this.InvouceNum= (this.sabha_code.concat(this.currentDate.getMonth(),this.currentDate.getFullYear(),lastGennum));
            // this.InvouceNum='PRS571120232'
            this.nextid= lastGennum+1;

                    const genInvNum = {
                        gen_num:this.nextid,
                   }
            await axios.put('/genaratenum/',genInvNum);
           
           if(this.user){
                this.payamount=parseFloat(this.reqdata[0].amount).toFixed(2)
                if(this.ipg=='BOC'){
                this.bankfee=(parseFloat(this.taxtPayment)*((100/(100-1))-1)).toFixed(2)

            }
            if(this.ipg=='people'){
                 this.bankfee=(parseFloat(this.taxtPayment)*0.01).toFixed(2)
            }
                
                this.grandPayTotal=(parseFloat(this.bankfee)+parseFloat(this.reqdata[0].amount)).toFixed(2)
           
           const onlineData = {
                   online_cus_nic:this.user.cus_nic,
                   online_sabha_code:this.sabha_code,
                   online_invoice_num:this.InvouceNum,
                   online_pay_amount:this.payamount,
                   online_pay_month:0,
                   online_pay_year:0,
                   online_pay_des:'Gully Bowser Payment',
                   pay_type:"gully",
                   vote:this.pay_vote,
                   online_pay_date:this.formattedDate()
                   
               // ... other key-value pairs
                   };
                   await axios.post("/onlinepaymenttemp/",onlineData);

           }
           this.postData.mid=this.sabha_code,
           this.postData.paytype=this.requestId,
            this.postData.amount=this.grandPayTotal,
            this.postData.referenceNumber=this.InvouceNum,
            this.postData.email=this.user.cus_email,
            this.postData.bill_to_forename=this.user.cus_nic,
            this.postData.bill_to_surname=this.user.cus_name,
            this.postData.bill_to_address_line1=this.requestId,
            this.postData.bill_to_address_line2=this.requestId,
            this.postData.bill_to_address_city=this.Sname,
            this.postData.bill_to_address_country='LK',
            
      axios
    //   .post('/processpaymentboc', this.postData, {
        .post('/process-payment', this.postData, {
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then((response) => {
          this.response = response.data;
        
        //   alert("response");
        //   alert(response.data);
          document.getElementById('formResponse').innerHTML=response.data;
          document.getElementById('submit').style.display="none";
        })
        .catch((error) => {
          this.error = error;
        }); 
    }else{
        // this.$router.push("/shoprentexist");
        this.$router.push('/assessmenttax');
    }

        },

        
    //     async initPaymentIntegration() {
    //         // Fetch session ID or any required data
    //         const sessionId = await this.getSessionId();
    //         // Configure the checkout with the session ID
    //         this.configureCheckout(sessionId);
    //     },
    //     async getSessionId() {
    //         // Fetch session ID from your API endpoint or any other source
    //         // Example: const response = await axios.get('/get-session-id');
    //         // Example: return response.data.sessionId;
    //         // For the purpose of this example, returning a mock session ID
    //     try {
    //         const response = axios.post('/processpaymentboc/', this.postData, {
    //     //  axios.post('/processpaymentboc/', this.postData, {
    //         headers: {
    //             'Content-Type': 'application/json',
    //         },
    //     });

    //     // Assuming the response contains the sessionId in response.data
    //     const sessionId = response.data.session.id;

    //     return sessionId;
    // } catch (error) {
    //     console.error('Error fetching session ID:', error);
    //     throw error; // Rethrow the error to be handled elsewhere if necessary
    // }
    //         // return '<your_initiate_checkout_session_ID>';
    //     },
    //     configureCheckout(sessionId) {
    //         // Configure the Checkout object
    //         this.Checkout.configure({
    //             session: {
    //                 id: sessionId
    //             }
    //         });
    //     },
    //     showPaymentPage() {
    //         // Show the payment page using Checkout object
    //         this.Checkout.showPaymentPage();
    //     },
    //     errorCallback(error) {
    //         console.log(JSON.stringify(error));
    //     },
    //     cancelCallback() {
    //         console.log('Payment cancelled');
    //     },
    

        
        scrollToTop() {
            window.scrollTo(0, 0);
        },
     
        
        getMonthName:function (monthNumber) {
            const date = new Date();
            date.setMonth(monthNumber);

            return date.toLocaleString('en-US', { month: 'long' });
            },

        ShowMonthName(){
            this.monthName=this.getMonthName(this.month);
        },
        btnenable(){
            if(this.checkVal==true){
                document.getElementById('formResponse').style.display='none'
                this.disableButton = true;
                // let submitButton = document.getElementById('payboc');
                // submitButton.disabled = true;
                // document.getElementById('payboc').disabled=true


            }else{
                document.getElementById('formResponse').style.display='block'
                // document.getElementById('payboc').disabled=false
                this.disableButton = !this.disableButton;
            }
        },  

       
        
    
}
}
</script>





<style scoped>
.register-container {
    padding: 1.5rem 9%;
    min-height: 80vh;
   background-image: url("../assets/images/regbacground.jpg");
  background-repeat: no-repeat;
  background-size:cover;
}

.register-container .register-form-container {
    background: #ffffffe9;

}

/* .register-container .register-form-container form {
    position: relative;
    left: 50%;
    transform: translate(-50%, 0%);
    max-width: 70rem;
    width: 100%;
    box-shadow: 0 1rem 1rem rgba(0, 0, 0, 0.05);
    border: 0.1rem solid rgba(0, 0, 0, 0.2);
    padding: 1rem;
    border-radius: 0.5rem;
    animation: fadeUp 0.4s linear;
} */

.register-container .register-form-container form h3 {
    /* padding-bottom: 0.1rem; */
    font-size: 1.9rem;
    text-transform: uppercase;
    color: #130f40;
    /* margin: 0; */
    text-align: center;
    
}

.register-container .register-form-container form h4 {
    /* padding-bottom: 0.2rem; */
    font-size: 1.6rem;
    text-transform: uppercase;
    color: #130f40;
    /* margin: 0; */
    text-align: left;
    
}

.register-container .register-form-container form h5 {
    padding-bottom: 0.2rem;
    font-size: 1.4rem;
    text-transform: uppercase;
    color: #130f40;
    /* margin: 0; */
    text-align: left;
    
}

.register-container .register-form-container  pre {
    /* padding-bottom: 0.2rem; */
    font-size: 1.0rem;
    text-transform: uppercase;
    color: #130f40;
    /* margin: 0; */
    text-align: right;
    padding-top: 1%;
    padding-right: 2%;
    
}
.register-container .register-form-container form h6 {
    /* padding-bottom: 0.2rem; */
    font-size: 1.25rem;
    /* text-transform: uppercase; */
    color: #130f40;
    /* margin: 0; */
    text-align: left;
    
}
.register-container .register-form-container form .form-control {
    margin: 0.7rem 0;
    border-radius: 0.5rem;
    /* background: #f7f7f7; */
    /* padding: 2rem 1.2rem; */
    font-size: 1.5rem;
    color: #130f40;
    text-transform: none;
    width: 100%;
    border: none;
   
}

.register-container .register-form-container form label {
    font-size: 1.5rem;
    margin: 0;
    padding: 0.6rem;
}

.register-container .register-form-container form span {
    font-size: 25px;
    /* padding-left: 5px;
    padding-right: 40px; */
    text-align: center;
    color: #620a0a;
}


.register-container .register-form-container form .btn {
    margin: 1rem 0;
    width: 10%;
    /* height: 25px; */
    text-align: center;
    align-items: center;
    background: #620a0a;
    
}


.register-container .register-form-container form p {
    padding-top: 0.75rem;
    font-size: 1rem;
    color: #666;
    margin: 0;
}

.register-container .register-form-container form p a {
    color: #27ae60;
}

.register-container .register-form-container form p a:hover {
    color: #130f40;
    text-decoration: underline;
}

.register-container .register-form-container form .form-group  {
    margin: 0;
}

.register-container .register-form-container form .form-group  .error-mess {
    font-size: 5rem;
    position: relative;
    color: rgb(243, 47, 47);
    margin: 0;
    padding: 0;
    width: 100%;

}

 .heading{
    padding: 0;
 }
/* Table */
.bg-light-gray {
    background-color: #f7f7f7;
}

.table thead th {
    vertical-align: bottom;
    border-bottom: 0px solid #dee2e6;
}

.table-responsive{
    padding-left: 3.5rem;
    width: 95%;
  /* align:center; */
}

.table-responsive1{
    padding-left: 8rem;
    /* width: 95%; */
  /* align:center; */
}
.table1{
  align-items: center;
    width: 90%;
    font-size:small;
   
  /* align:center; */
}
.table1 td
 {
    padding: .25rem;
    vertical-align: top;
    border-top: 1px solid #dee2e6;
    border-bottom: 1px solid #dee2e6;
    width: auto;
    text-align: center;
} 
.table td,
.table th {
    padding: .25rem;
    vertical-align: top;
    border-top: 1px solid #dee2e6;
    width: 30%;
} 
.aling{
    align-items: center;
    text-align: center;
align-content: center;
/* padding-right: 15%; */
}  
</style>
